import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Modal, Result, App } from 'antd';
import { MailOutlined, ArrowLeftOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import userService from '../services/userService';

const { Title, Text } = Typography;

const ForgotPassword = () => {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const result = await userService.forgotPassword(values.email);
      
      if (result.success) {
        setUserEmail(values.email);
        setIsSuccessModalVisible(true);
        form.resetFields();
      } else {
        message.error(result.message || 'Failed to send password reset email');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      message.error('Failed to send password reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleModalOk = () => {
    setIsSuccessModalVisible(false);
    navigate('/login');
  };

  return (
    <div style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px'
    }}>
      <Card style={{ 
        width: '100%', 
        maxWidth: 400, 
        padding: '20px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        borderRadius: '8px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <Title level={2} style={{ color: '#2E86AB', marginBottom: '8px', fontWeight: 'bold' }}>
          <div className="mb-4">
          <img 
            src="/logo.png" 
            alt="TapLearnGo Logo"
            className="w-3/4 h-auto mx-auto"
            style={{ backgroundColor: 'transparent', marginTop: '-20px' }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
          </Title>
          <Text type="secondary">Creating a culture of learning</Text>
        </div>

        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
          <Title level={4} style={{ margin: 0 }}>Reset Password</Title>
          <Text type="secondary" style={{ fontSize: '14px', marginTop: '8px', display: 'block' }}>
            Enter your email address and we'll send you a link to reset your password.
          </Text>
        </div>

        <Form
          form={form}
          name="forgot-password"
          onFinish={onFinish}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please enter your email!' },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
          >
            <Input 
              prefix={<MailOutlined />} 
              placeholder="Enter your email address" 
            />
          </Form.Item>

          <Form.Item style={{ marginTop: '24px', marginBottom: '16px' }}>
            <Button 
             
              htmlType="submit" 
              loading={loading}
              style={{ 
                width: '100%', 
                height: '40px'
              }}
            >
              Send Reset Link
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center' }}>
            <Button 
              type="link" 
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/login')}
            >
              Back to Login
            </Button>
          </div>
        </Form>
      </Card>

      {/* Success Modal */}
      <Modal
        open={isSuccessModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalOk}
        footer={[
          <Button key="ok" type="default" onClick={handleModalOk}>
            Go to Login
          </Button>
        ]}
        centered
        closable={false}
        maskClosable={false}
      >
        <Result
          icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
          title="Reset Link Sent!"
          subTitle={
            <div style={{ textAlign: 'center' }}>
              <p>A password reset link has been sent to:</p>
              <p style={{ fontWeight: 'bold', color: '#2E86AB' }}>{userEmail}</p>
              <p style={{ marginTop: '12px', fontSize: '14px', color: '#666' }}>
                Please check your email inbox and follow the instructions to reset your password.
              </p>
            </div>
          }
        />
      </Modal>
    </div>
  );
};

export default ForgotPassword;